// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"3045": "e5b33855","4777": "13f44d2c","4896": "0a49cdea","5213": "e277b8af","631": "99e9e1d9","8971": "25e50ce7","8978": "9b02ad1a",}[chunkId] + ".css"
}